import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit, OnDestroy {
  selectedItem: string = '';
  items = [
    { "Name": 'Governing Body', "Url": 'governing-body' },
    { "Name": 'Message of Chairman', "Url": 'message-of-chairman' },
    { "Name": 'Message of Chief Patron', "Url": 'message-of-chief-patron' },
    { "Name": 'Message of Vice Chairman', "Url": 'message-of-vice-chairman' },
    { "Name": 'Message of Vice Principal', "Url": 'message-of-vice-principal' },
    { "Name": 'Message of Principal', "Url": 'message-of-principal' },
    { "Name": 'Message of Secretary General', "Url": 'secretory-general-message' },
    { "Name": 'Message of Senior Vice President', "Url": 'message-of-senior-vice-president' },
    { "Name": 'Teaching staff', "Url": 'teacher-information' },
    { "Name": 'Non Teaching Staff', "Url": 'staff-information' },
    { "Name": 'Secretary General Alias', "Url": 'superintendent-msg' },
    { "Name": 'assistant-superintendent-msg', "Url": 'assistant-superintendent-msg' },
    { "Name": 'superintendent-msg', "Url": 'superintendent-msg' },
  ];
  imageLoaded = false;
  fetchinData = true;
  ImageAlbums: any;
  GBs: any;
  GBs1: any;
  GBs2: any;
  TeacherInfo: any;
  GBms: any;
  GBms1: any;
  selectedItemName = '';
  private ngUnsubscribe = new Subject();

  constructor(private route: ActivatedRoute, private location: Location, private appService: AppService, private router: Router, private _changeDetectorRef: ChangeDetectorRef,) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      let item = params.get("item");
      if (!item) {
        const fullPath = this.location.path();
        item = fullPath.replace(/^\/+/, '').replace(/^administration\//, '');
      }

      const normalizedItem = item ? item.trim().toLowerCase() : '';
      const matchedItem = this.items.find(i => i.Url === normalizedItem) || this.getAliasItem(normalizedItem);

      if (matchedItem) {
        this.selectedItem = matchedItem.Url;
        this.selectedItemName = matchedItem.Name;
      } else {
        this.selectedItem = this.items[0].Url;
        this.selectedItemName = this.items[0].Name;
        this.location.replaceState(`/${this.selectedItem}`);
      }
      this.FetchData();
    });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchData() {
    this._changeDetectorRef.markForCheck();
    this.fetchinData = true;
    if (this.selectedItem === 'governing-body') {
      this.FetchGbs();
    } else if (this.selectedItem === 'teacher-information') {
      this.FetchTeacherInfo();
    } else {
      this.FetchGbms();
    }
  }

  selectItem(item: string) {
    this.selectedItem = item;
    this.router.navigate([`/administration/${item}`]);
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  FetchGbs() {
    forkJoin([
      this.appService.getGBs(),
    ]).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        console.log(response, 'response Albums');

        this.GBs = response[0].data;

        if (this.GBs) {
          let m1 = this.GBs.slice(0, 1);
          this.GBs1 = m1[0];
          this.GBs2 = this.GBs.slice(1);
        }

        this.fetchinData = false;
      });
  }

  FetchTeacherInfo() {
    forkJoin([
      this.appService.getTeaherStaff(),
    ]).subscribe((response: any) => {
      console.log(response, 'response Albums');

      this.TeacherInfo = response[0].data;
      this.fetchinData = false;
    });
  }

  FetchGbms() {
    forkJoin([
      this.appService.getGBMessages(),
    ]).subscribe((response: any) => {
      console.log(response, 'response Albums');

      this.GBms = response[0].data;

      if (this.GBms) {
        this.GBms1 = this.getGBMessageByRoute(this.selectedItem);
      }

      this.fetchinData = false;
    });
  }

  private getGBMessageByRoute(route: string): any {
    if (!this.GBms || !route) {
      return null;
    }

    const normalized = route.replace(/^message-of-/, '').replace(/-/g, ' ').trim().toLowerCase();

    const exact = this.GBms.find((item: any) => item.GBDesignationName?.toLowerCase() === normalized);
    if (exact) {
      return exact;
    }

    const contains = this.GBms.find((item: any) => item.GBDesignationName?.toLowerCase().includes(normalized));
    if (contains) {
      return contains;
    }

    const routeLookup: { [key: string]: number } = {
      'message-of-chairman': 58,
      'message-of-chief-patron': 1,
      'message-of-principal': 6,
      'message-of-vice-chairman': 5,
      'message-of-vice-principal': 12,
      'secretory-general-message': 110,
      'message-of-senior-vice-president': 49,
      'message-of-vice-president': 49,
      'superintendent-msg': 6,
      'assistant-superintendent-msg': 12,


    };

    const id = routeLookup[route];
    if (id) {
      return this.GBms.find((item: any) => item.GBDesignationId == id);
    }

    return this.GBms[0];
  }

  private getAliasItem(item: string | null): any {
    if (!item) {
      return null;
    }

    const aliasMap: { [key: string]: string } = {
      'secretery-general-message': 'message-of-secretary-general',
      'secretary-general-message': 'message-of-secretary-general',
      'message-of-secretary-general': 'message-of-secretary-general',
      'message-of-senior-vice-president': 'message-of-senior-vice-president',
    };

    const normalized = item.toLowerCase();
    const target = aliasMap[normalized];
    return target ? this.items.find(i => i.Url === target) : null;
  }

  TransformUrl(value: string): string {
    if (value.includes('https://')) {
      return value;
    }
    else {
      return `https://${value}`;
    }
  }
}
